export default __webpack_public_path__ + "static/media/handball.65063c02.png";